import { UserRole } from "./userCurrent";

export type User = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    profileName: string;
    profileType: string;
    role: UserRole;
    status: UserStatus;
    tmpUser?: TmpUser;
    submitBy?: string;
    reviewStatus?: UserReviewStatus;
    reviewBy?: string;
    rejectReason?: string;
};

export type TmpUser = {
    userId: string;
    role: UserRole;
    firstName: string;
    lastName: string;
}

export enum UserReviewStatus {
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
}

export enum UserStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    PENDING = "PENDING",
    LOCKED = "LOCKED",
    PENDING_CREATE_APPROVAL = "PENDING_CREATE_APPROVAL",
    PENDING_ACTIVATION = "PENDING_ACTIVATION",
    PENDING_EDIT_APPROVAL = "PENDING_EDIT_APPROVAL",
    DRAFT = "DRAFT",
}
